import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./components/AuthContext";

import Navbar from "./components/Navbar";
import AdminPage from "./components/AdminPage";
import AddIssue from "./components/AddIssue";
import ViewIssues from "./components/ViewIssues";
import Statistics from "./components/Statistics";
import ResolvedIssues from "./components/ResolvedIssues";
import LoginLogs from "./components/LoginLogs";
import TerminAssign from "./components/TerminAssign";
import ThreatList from "./components/ThreatList";
import { buildAracTakipAccess } from "./utils/permissions";

const AracTakipRoutes = () => {
  const { role, user, userPermissions, loading } = useAuth();
  const access = buildAracTakipAccess(role, userPermissions);

  if (loading) return <div className="text-center mt-10">Yükleniyor...</div>;
  if (!user) return <div className="text-center mt-10">Yetki bulunamadı.</div>;

  const hasAnyAccess = Object.values(access).some(Boolean);
  if (!hasAnyAccess) {
    return <div className="text-center mt-10">Bu projeyi görüntüleme yetkiniz yok.</div>;
  }

  const getDefaultRoute = () => {
    if (access.canAdmin) return "/arac-takip/admin";
    if (access.canAdd) return "/arac-takip/add-issue";
    if (access.canView) return "/arac-takip/view-issues";
    if (access.canResolved) return "/arac-takip/resolved-issues";
    if (access.canStats) return "/arac-takip/istatistikler";
    return "/secilen-proje";
  };

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Navigate to={getDefaultRoute()} />} />

        {access.canAdmin && <Route path="admin" element={<AdminPage />} />}
        {access.canAdd && <Route path="add-issue" element={<AddIssue />} />}
        {access.canView && <Route path="view-issues" element={<ViewIssues />} />}
        {access.canResolved && <Route path="resolved-issues" element={<ResolvedIssues />} />}
        {access.canStats && <Route path="istatistikler" element={<Statistics />} />}
        {access.canLogs && <Route path="giris-loglari" element={<LoginLogs />} />}
        {access.canTermin && <Route path="termin-assign" element={<TerminAssign />} />}
        {access.canThreat && <Route path="tehdit-listesi" element={<ThreatList />} />}

        <Route path="*" element={<Navigate to={getDefaultRoute()} />} />
      </Routes>
    </>
  );
};

const AracTakip = () => (
  <AuthProvider>
    <AracTakipRoutes />
  </AuthProvider>
);

export default AracTakip;
